import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/edit.svg'
import _imports_1 from '@/assets/images/edit-hover.svg'


const _withScopeId = n => (_pushScopeId("data-v-b633cc4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "edit",
  class: "position-absolute"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "edit active",
  class: "position-absolute"
}, null, -1))
const _hoisted_3 = ["data-bs-toggle", "data-bs-target"]
const _hoisted_4 = ["innerHTML"]

import { computed, PropType, ref } from 'vue'
import { CardType, COMMENT_CARD_MENU } from '@/constants/index'


export default /*#__PURE__*/_defineComponent({
  props: {
  dataBs: {
    type: Array,
    default: () => [['', '']],
  },
  menu: {
    type: Array as () => PropType<{ title: string } | null>,
  },
  iconAppear: String,
  revert: {
    type: Boolean,
    default: false,
  },
},
  emits: ['getPostId'],
  setup(__props, { emit }) {

const props = __props





const openMainMenu = ref<boolean>(false)

const menus = computed<Array<CardType>>(() => {
  const { menu } = props

  return !menu ? COMMENT_CARD_MENU : [COMMENT_CARD_MENU.reduce((t, v, i) => (menu[i] ? [...t, { ...v, title: menu[i].title ?? v.title, icon: menu[i].icon ?? v.icon }] : t), [])]
})

const closeMainMenu = (): void => {
  openMainMenu.value = false
}

const handleOpenMainMenu = (): void => {
  openMainMenu.value = !openMainMenu.value
  emit('getPostId')
}

return (_ctx: any,_cache: any) => {
  const _directive_click_away = _resolveDirective("click-away")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'revert-direction': __props.revert }, 'menu d-lg-flex position-relative justify-content-center align-items-center ms-3']),
    onClick: handleOpenMainMenu
  }, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", {
      class: _normalizeClass([openMainMenu.value ? 'active' : '', 'position-absolute main-menu z-index'])
    }, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menus), (menu, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: menu.id,
            "data-bs-toggle": __props.dataBs[index][0],
            "data-bs-target": __props.dataBs[index][1]
          }, [
            (!__props.iconAppear)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "icon",
                  innerHTML: menu.icon
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true),
            _createElementVNode("span", null, _toDisplayString(menu.title), 1)
          ], 8, _hoisted_3))
        }), 128))
      ])
    ], 2)
  ], 2)), [
    [_directive_click_away, closeMainMenu]
  ])
}
}

})